<ui-table
  *ngIf="pager$ | async as pager"
  [fields]="fields"
  [pager]="pager"
  [itemsPage]="(page$ | async)?.current"
  [itemsPerPage]="(page$ | async)?.limit"
  [reload]="reload$"
  [contextMenuActions]="contextMenus"
  (select)="selectHandler($event)">
</ui-table>
